import styled from 'styled-components'
import {VesselTagResult} from '../vessel-tag/vessel-tag-result'
import {spacing} from '../../theme/spacing'
import {Tree} from '../base/tree/tree'

const Styled = {
    VesselTagResult: styled(VesselTagResult)`
        margin-bottom: ${spacing(0.5)};
    `,
    ElipsisSpan: styled.span`
        text-overflow: ellipsis;
        text-wrap-mode: nowrap;
        display: block;
        overflow-x: hidden;
    `,
    Count: styled.span`
        color: ${({theme}) => theme.colors.text.secondary};
    `,
    Tree: styled(Tree)`
        &[data-disabled]: {
            opacity: 0.5;
            pointer-events: none;
            cursor: default !important;
        }
    `,
}

export default Styled
